<ng-container *ngIf="hasItems">
    <div class="sub-nav-wrapper">
        <nb-card>
            <nb-menu [items]="items" class="menu-items" tag="sub-menu"></nb-menu>
        </nb-card>
    </div>
</ng-container>
<!-- <nb-card>
    <p>Hello world</p>
</nb-card> -->

